import React from 'react';
import './Menu.css';
import MenuInterior from '../menuInterior/MenuInterior';

export default class Menu extends React.Component{
    render(){
        return(
            <aside className="column is-2 aside hero is-fullheight is-hidden-mobile is-primary">
                <MenuInterior />
            </aside>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/menu/Menu.js